import React from 'react'
import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { PrivateRoute } from '../../../auth'
import MessageTemplate from './components/message-templates/MessageTemplate'
import MessageSender from './components/message-senders/MessageSender'
import { DEFAULT_ROLES } from '../../../../common/core/_consts'


const MessageTemplatePage: React.FC = () => {    
    return (
        <Routes>
            <Route element={<Outlet />}>
                <Route
                    path='templates'
                    element={
                        <PrivateRoute roles={DEFAULT_ROLES} >
                            <MessageTemplate />
                        </PrivateRoute>
                    }
                />
                <Route
                    path='senders'
                    element={
                        <PrivateRoute roles={DEFAULT_ROLES} >
                            <MessageSender />
                        </PrivateRoute>
                    }
                />
                <Route index element={<Navigate to='templates' />} />
            </Route>
        </Routes>
    )
}

export default MessageTemplatePage
